import { theme } from '@frontend/theme';
import { Button, DynamicFieldAttributes, PopoverDialog, usePopoverDialog } from '@frontend/design-system';
import { useContentComposer } from '../../content-composer/content-composer-provider';
import { useEmailHeader } from './email-header-context';

export const DynamicFieldPickerPopover = (props: ReturnType<typeof usePopoverDialog>) => {
  const { setSubject, subject, subjectProps } = useEmailHeader();
  const { subjectDynamicFields } = useContentComposer();

  const onSelect = (field: DynamicFieldAttributes) => {
    const newSubject = subject + '[' + field.label + ']';
    subjectProps?.onChange({ ...subjectProps, value: newSubject, name: 'subject' });
    setSubject(newSubject);
    props.close();
  };

  return (
    <PopoverDialog
      {...props.getDialogProps()}
      returnFocus={false}
      css={{
        width: 400,
        borderRadius: theme.borderRadius.medium,
      }}
    >
      {subjectDynamicFields?.map((field) => (
        <Button
          variant='secondary'
          key={field.symbol}
          size='small'
          onClick={() => onSelect(field)}
          css={{
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
            height: 'auto',
            width: 'auto',
            padding: theme.spacing(0.5, 1),
          }}
        >
          {field.label}
        </Button>
      ))}
    </PopoverDialog>
  );
};
